import { Box, Button } from "@mui/material";
import React from "react";
import { subChildParentStyle } from "./SubChildStyle";
import { useNavigate } from "react-router-dom";
import { useUpdateForm } from "../../context/UpdateFormProvider";

const SubChildLayout = (props) => {
  const { children, path, buttonName } = props;
  const navigate = useNavigate();
  const {setUpdateFormValues} = useUpdateForm()

  return (
    <Box sx={subChildParentStyle}>
      <Box sx={{display:"inline-flex", justifyContent:"center", width: "100%", position: "relative", zIndex:"1001"}}>
        <Button variant="contained" size="small"
        sx={{  position: "absolute", top: "95px", left: "10px", height: "40px", width: "fit-content", right: "10px", zIndex: "1000"}}
         onClick={() => {
          navigate(path);
          setUpdateFormValues({})
          }}>
          {buttonName}
        </Button>
      </Box>
      {children}
    </Box>
  );
};

export default SubChildLayout;
